<h2 mat-dialog-title>HELP TEST LIMIT</h2>
<mat-dialog-content>

      <div style="margin-left: 16px;">
        <Small>
            With dynamic limits you can have calculated limits per player instead of fixed limits for a test.
        </Small><br/>
        <small>You can either use a multiplier test, or use a formula.</small>
        <br/>
        <br/>

        <label>Use multiplier test </label><br/>
        <small>
          The entered limit values will be multiplied with the latest value of the selected test.
        </small> <br/><br/>
         <label>Use formula </label><br/>
        <small>
          With a formula you can have a more complex calculation of the limit values.
        </small> 
        <small>
          You can enter any calculation by using the tests abbreviations in the formula.
        </small> <br/>
      <small>Use [Limit] to represent the limit value, must be included in the formula.</small><br/>
      <small>Use decimal point if entering decimal numbers.</small><br/>
      <small>To reference a test value, enter the test abbrevation in []. <br/> Example: <PRE>Round([Limit]+[G_BODY_HEIGHT]*1.2,0)</PRE></small><br/>
      <small>Parenthesis can be used.</small>
      <br/>
      <small>Operators: +, - , *, /, % (modulus), ** (exponential)</small><br/>
      <small>Functions: Round(), Abs(), Pow(), and more...</small><br/>
    </div>
    </mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>CLOSE</button>

</mat-dialog-actions>